export default function isValidUrl(url: string, excludedProtocols: string[] = ['javascript:']) {
  try {
    const parsed = new URL(url);
    return !excludedProtocols.includes(parsed.protocol);
  } catch {
    return false;
  }
}
